import { Schema } from 'effect';

import type { CurrencyT } from '../../../../config/currency';

import type { OrderItem } from '../../../bind/order';
import { GtmAddPaymentInfoEventSchema } from '@vs-shop/schemas/gtm/add-payment-info';
import type { OrderDetail } from '../../../schema/openapi/backend';
import type { OrderShipmentStorageT } from '../../../service/orderShipment/OrderShipment';

/**
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_payment_info
 */
export const createAddPaymentInfoPayloadFromOrder = (
  orderData: OrderDetail,
  cartItems: OrderItem[],
  shipmentData: OrderShipmentStorageT,
  currency: CurrencyT
) => {
  const paymentPrice = shipmentData.payment.paymentPriceWithoutVat / 100;

  return Schema.decodeEffect(GtmAddPaymentInfoEventSchema)({
    event: 'track.add_payment_info',
    ecommerce: {
      currency,
      value: (orderData.frontAllItemsPriceWithoutVatAfterDiscount ?? 0) / 100,
      payment_type: shipmentData.payment.paymentName,
      payment_code: shipmentData.payment.paymentCode,
      payment_price: paymentPrice,
      items: cartItems.map((item) => ({
        id: item.variant.code,
        name: item.productName ?? '',
        price: (item.variant.priceWithoutTax ?? 0) / 100,
        price_with_tax: (item.frontUnitPriceWithVat ?? 0) / 100,
        quantity: item.quantity,
      })),
    },
  });
};
